import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ResetPasswordPopUp from './ResetPasswordPopUp';
import AddPasswordPopUp from './AddPasswordPopUp';
import AddTwitterPopUp from './AddTwitterPopUp';
import DeleteDataPopUp from './DeleteDataPopUp';
import { FormattedMessage } from 'react-intl';
import axiosInterceptor from '../../axiosInterceptor';

const AccountSettings = ({ email, logout, history }) => {
    const [passwordExists, setPasswordExists] = useState(true);
    const [twitterExists, setTwitterExists] = useState(true);
    useEffect(() => {
        checkPasswordStatus();
        checkTwitterUser();
    });

    let checkPasswordStatus = async () => {
        const password_data = await axiosInterceptor().post(
            'twitter/checkPassword',
            { email: email }
        );

        if (password_data?.data?.check == 'Password Exists') {
            setPasswordExists(true);
        } else {
            setPasswordExists(false);
        }
    };

    let checkTwitterUser = async () => {
        const user_data = await axiosInterceptor().post(
            'twitter/checkTwitterUser',
            { email: email }
        );

        if (user_data?.data?.check == 'Success') {
            setTwitterExists(false);
        } else {
            setTwitterExists(true);
        }
    };

    return (
        <Container className="text-left p-4">
            {passwordExists && (
                <Row className="align-items-center">
                    <Col sm={8}>
                        <p className="h5">
                            <FormattedMessage
                                id="Account.resetPasswordTitle"
                                defaultMessage="Reset Password"
                            />
                        </p>
                        <p className="text-muted">
                            <FormattedMessage
                                id="Account.resetPassword"
                                defaultMessage="Reset Your Password with your current passowrd"
                            />
                        </p>
                    </Col>
                    <Col>
                        <ResetPasswordPopUp />
                    </Col>
                </Row>
            )}

            {!passwordExists && (
                <Row className="align-items-center">
                    <Col sm={8}>
                        <p className="h5">
                            <FormattedMessage
                                id="Account.addPasswordTitle"
                                defaultMessage="Add Password"
                            />
                        </p>
                        <p className="text-muted">
                            <FormattedMessage
                                id="Account.addPassword"
                                defaultMessage="By adding a password to your account, you'll be able to use the regular sign-in procedure in addition to the Twitter login option"
                            />
                        </p>
                    </Col>
                    <Col>
                        <AddPasswordPopUp />
                    </Col>
                </Row>
            )}

            {!twitterExists && (
                <Row className="align-items-center">
                    <Col sm={8}>
                        <p className="h5">
                            <FormattedMessage
                                id="Account.addTwitterTitle"
                                defaultMessage="Link Twitter"
                            />
                        </p>
                        <p className="text-muted">
                            <FormattedMessage
                                id="Account.addTwitter"
                                defaultMessage="You can also sign-in to YourMorals using your Twitter account"
                            />
                        </p>
                    </Col>
                    <Col>
                        <AddTwitterPopUp email={email} />
                    </Col>
                </Row>
            )}

            <Row className="align-items-center">
                <Col sm={8}>
                    <p className="h5">
                        <FormattedMessage
                            id="Account.deleteData"
                            defaultMessage="Delete My Data"
                        />
                    </p>
                    <p className="text-muted">
                        <FormattedMessage
                            id="Account.deleteDataContent1"
                            defaultMessage="Only your answered survey and demographic data will be deleted"
                        />
                    </p>
                </Col>

                <Col>
                    <DeleteDataPopUp
                        email={email}
                        logout={logout}
                        history={history}
                        type="without-credentials"
                    />
                </Col>
            </Row>
            <Row className="align-items-center">
                <Col sm={8}>
                    <p className="h5">
                        <FormattedMessage
                            id="Account.deleteAccountTitle"
                            defaultMessage="Delete My Account"
                        />
                    </p>
                    <p className="text-muted">
                        <FormattedMessage
                            id="Account.deleteAccountContent"
                            defaultMessage="By deleting your account, all of your surveys, account information
            and demographic data will be deleted"
                        />
                    </p>
                </Col>

                <Col>
                    <DeleteDataPopUp
                        email={email}
                        logout={logout}
                        history={history}
                        type="with-credentials"
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default AccountSettings;
